export default __webpack_public_path__ + "static/media/icon-web-hosting.9593b37d.svg";